import React, { useEffect, useState } from "react";
import axios, { AxiosError } from "axios";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import Cookies from "js-cookie";
import { pdf, PDFDownloadLink } from "@react-pdf/renderer";

import { ShimmerCategoryItem, ShimmerPostList } from "react-shimmer-effects";
import { Modal } from "@mui/material";
import PdfPage from "../../../actions/pdf_part/PdfPage";
import CustomLoader from "../../../components/Loading/TopBarLoader";
import MDButton from "../../../components/MDButton";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";

import Paginate from "../../../components/Paginate/Paginate";
import PelakComponent from "../../../components/Pelak/pelakComponent";
import PdfWeightPage from "../../../actions/pdf_part/PdfReportWeight/PdfWeightPage";
import PdfReceiptWeight from "../../../actions/pdf_part/PdfReceiptWeight/PdfReceiptWeight";
import { FaEdit, FaImage, FaTrash, FaPrint } from "react-icons/fa";
import { deleteCargo } from "../../../actions/cargo/cargo";
import ImageViewer from "../../../components/Image/ImageViwer";
import { Chip, Badge, Tooltip } from "@heroui/react";
import { Button } from "@heroui/button";

export default function ReportListWeightBridgePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJens, setSelectedJens] = useState([]);

  const handleOpenModal = (jensList) => {
    setSelectedJens(jensList);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedJens([]);
  };
  const [reportData, setReportData] = useState([]);
  const [paging, setPaginate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingExport, setLoadingExport] = useState(false);
  const [loadingExportPdf, setLoadingExportPdf] = useState(false);
  const [loadingPrintReceipt, setLoadingPrintReceipt] = useState({});
  const [searchParams] = useSearchParams();
  const [selectedItems, setSelectedItems] = useState([]);
  const [totals, setTotals] = useState(null);

  const handleCheckboxChange = (item) => {
    if (selectedItems.includes(item)) {
      setSelectedItems(selectedItems.filter(i => i.id !== item.id));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };
  useEffect(() => {
    console.log(
      selectedItems,
    );
  }, [selectedItems]);
  const payload = localStorage.getItem("reportPayloadWeightBridge");
  const downloadAllData = async () => {
    try {
      setLoadingExportPdf(true)
      const token = Cookies.get("login_token");

      const parsedPayload = JSON.parse(payload);

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/ReportWeb/Reports/reportAllWeightBridge`, parsedPayload,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
      const blob = await pdf(<PdfWeightPage data={response.data.data} totals={response.data.meta.totals} />).toBlob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "گزارشات_عملکرد_باسکول_بارگو.pdf";
      link.click();
      setLoadingExportPdf(false)
    } catch (error) {
      console.log(error);
      if (axios.isAxiosError(error)) {
        const axiosError = error;
        if (axiosError.response && axiosError.response.status === 401) {
          toast.error("نشست منقضی شده !");

          navigate("/authentication/sign-in");
        }
        return {
          status: "error",
          message: axiosError.message || "خطا در اتصال به سرور",
        };
      }
      toast.error("خطا در دریافت اطلاعات!");
    }
  };

  const handlePrintReceipt = async (item) => {
    try {
      setLoadingPrintReceipt(prev => ({ ...prev, [item.id]: true }));
      const blob = await pdf(<PdfReceiptWeight data={[item]} />).toBlob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `قبض_${item.cargo_code || item.id}.pdf`;
      link.click();
      setLoadingPrintReceipt(prev => ({ ...prev, [item.id]: false }));
      toast.success("قبض با موفقیت دانلود شد!");
    } catch (error) {
      console.log(error);
      setLoadingPrintReceipt(prev => ({ ...prev, [item.id]: false }));
      toast.error("خطا در تولید قبض!");
    }
  };

  useEffect(() => {

    if (payload) {
      const params = new URLSearchParams(searchParams);
      const fetchData = async () => {
        try {
          const token = Cookies.get("login_token");

          setLoading(true);
          const parsedPayload = JSON.parse(payload);

          params.forEach((value, key) => {
            parsedPayload[key] = value;
          });

          const response = await axios.post(`${process.env.REACT_APP_API_URL}/ReportWeb/Reports/reportWeightBridge`, parsedPayload,
            {
              headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });
          setReportData(response.data.data);
          setPaginate(response.data.meta.links);
          setTotals(response.data.meta.totals);
          setLoading(false);
        } catch (error) {
          if (axios.isAxiosError(error)) {
            const axiosError = error;
            if (axiosError.response && axiosError.response.status === 401) {
              toast.error("نشست منقضی شده !");

              navigate("/authentication/sign-in");
            }
            return {
              status: "error",
              message: axiosError.message || "خطا در اتصال به سرور",
            };
          }
          toast.error("خطا در دریافت اطلاعات!");
        }
      };
      fetchData();
    }
  }, [searchParams]);

  const navigate = useNavigate();

  return (
    <div>
      <CustomLoader isLoading={loading} />
      <DashboardLayout>
        <div className={"flex w-full items-center gap-4"}>

          {selectedItems.length > 0 &&
            <PDFDownloadLink
              className="flex items-center px-5 py-2.5 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              document={<PdfWeightPage data={selectedItems} />}
              fileName="bargo-weight-report.pdf"
            >
              خروجی پی دی اف
              <img src="/images/pdf.svg" alt="" className="w-5 h-5 ms-4" />

            </PDFDownloadLink>
          }
          <Button
            color="primary"
            onClick={() => downloadAllData()}
            isLoading={loadingExportPdf}
            className="flex items-center px-5 py-2.5 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            {loadingExportPdf ? "درحال دریافت گزارش..." : "خروجی پی دی اف تمامی گزارشات"}
            <img src="/images/pdf.svg" alt="" className="w-5 h-5 ms-4"/>
          </Button>
        </div>
        {loading ? <div className={"mt-5"}>
            <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} />
          </div>
          : <div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-5">
              <div className="bg-white dark:bg-boxdark p-4 rounded-lg shadow-md border-r-4 border-blue-500">
                <h3 className="text-gray-500 dark:text-gray-400 text-sm font-medium">تعداد بارگیری</h3>
                <p className="text-2xl font-bold text-gray-800 dark:text-white mt-2">
                  {totals?.loading_count || 0}
                </p>
              </div>
              <div className="bg-white dark:bg-boxdark p-4 rounded-lg shadow-md border-r-4 border-green-500">
                <h3 className="text-gray-500 dark:text-gray-400 text-sm font-medium">تعداد تخلیه</h3>
                <p className="text-2xl font-bold text-gray-800 dark:text-white mt-2">
                  {totals?.unloading_count || 0}
                </p>
              </div>
              <div className="bg-white dark:bg-boxdark p-4 rounded-lg shadow-md border-r-4 border-orange-500">
                <h3 className="text-gray-500 dark:text-gray-400 text-sm font-medium">مجموع تناژ بارگیری</h3>
                <p className="text-2xl font-bold text-gray-800 dark:text-white mt-2">
                  {totals?.loading_tonnage ? Number(totals.loading_tonnage).toLocaleString() : 0}
                </p>
              </div>
              <div className="bg-white dark:bg-boxdark p-4 rounded-lg shadow-md border-r-4 border-red-500">
                <h3 className="text-gray-500 dark:text-gray-400 text-sm font-medium">مجموع تناژ تخلیه</h3>
                <p className="text-2xl font-bold text-gray-800 dark:text-white mt-2">
                  {totals?.unloading_tonnage ? Number(totals.unloading_tonnage).toLocaleString() : 0}
                </p>
              </div>
            </div>
            <div className="mt-5 relative overflow-x-auto shadow-md sm:rounded-lg">

            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead
                className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="px-6 py-3">انتخاب</th>
                <th scope="col" className="px-6 py-3" style={{ whiteSpace: "nowrap" }}>
                  تاریخ و ساعت
                </th>
                <th scope="col" className="px-6 py-3" style={{ whiteSpace: "nowrap" }}>
                  شماره قبض
                </th>
                <th scope="col" className="px-10 text-center py-3" style={{ whiteSpace: "nowrap" }}>
                  توزین خالی
                </th>
                <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                  توزین پر
                </th>
                <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                  توزین خالص
                </th>
                <th scope="col" className="px-6 text-center justify-center w-full py-3"
                    style={{ whiteSpace: "nowrap" }}>
                  پلاک
                </th>
                <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                  دستگاه
                </th>
                <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                  نوع دستگاه
                </th>
                <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                  راننده
                </th>

                <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                  کالا
                </th>
                <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                  کد کالا
                </th>
                <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                  مبدا
                </th>
                <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                  مقصد
                </th>
                <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                  نام مسئول عملیات
                </th>
                <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                  نوع عملیات
                </th>
                <th scope="col" className="px-16 py-3 text-center justify-center" style={{ whiteSpace: "nowrap" }}>
                  عملیات
                </th>
              </tr>
              </thead>
              <tbody>
              {reportData.map((item, index) => (
                <tr
                  key={index}
                  className={`border-b hover:bg-gray-50 dark:bg-boxdark dark:border-gray-700 dark:hover:bg-gray-600 ${
                    index % 2 === 0 ? "bg-white" : "bg-[#f6f6f6]"
                  }`}
                >
                  <td className="px-3 py-2">
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(item)}
                      onChange={() => handleCheckboxChange(item)}
                    />
                  </td>

                  <td className="px-3 py-2 font-semibold text-gray-900 dark:text-white" dir="ltr"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["date"] ? item["date"] : <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="px-3 py-2 font-semibold text-gray-900 dark:text-white">
                    {item["cargo_code"] || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="text-center py-2">
                    {item["weight_empty"] ? (
                      <Chip radius="md">{item["weight_empty"]}</Chip>
                    ) : (
                      <Chip radius="md">ثبت نشده</Chip>
                    )}
                  </td>

                  <td className="text-center py-2">
                    {item["weight_fill"] ? (
                      <Chip radius="md">{item["weight_fill"]}</Chip>
                    ) : (
                      <Chip radius="md">ثبت نشده</Chip>
                    )}
                  </td>
                  <td className="text-center py-2">
                    {item["weight_fill"] && item["weight_empty"] ? (
                      <Badge color="primary" content="" placement="top-right" shape="circle" size={"sm"}>
                        <Chip radius="md">{item["weight_fill"] - item["weight_empty"]}</Chip>
                      </Badge>
                    ) : (
                      <Chip radius="md">ثبت نشده</Chip>
                    )}
                  </td>
                  <td className="py-2 text-center font-semibold text-gray-900 dark:text-white">
                    <PelakComponent pelak={item["plate"]} />
                  </td>

                  <td className="py-2 text-center font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["machine"]?.name || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="py-2 text-center font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["machine"]?.type || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="py-2 text-center font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["driver"]?.name || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="text-center px-6 py-2 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["weight_jens"]?.title || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="text-center px-6 py-2 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["weight_jens_code"]?.title || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="text-center px-6 py-2 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["origin"]?.title || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="text-center px-6 py-2 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["destination"]?.title || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="text-center px-6 py-2 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["user"]?.name || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="text-center px-6 py-2 font-semibold text-gray-900 dark:text-white"
                      style={{ whiteSpace: "nowrap" }}>
                    {item["type"] || <span className="font-normal">ثبت نشده</span>}
                  </td>

                  <td className="p-2 text-center">
                    <div className="flex items-center justify-center gap-4">
                      <ImageViewer images={item["image_weight_bridge"]} />

                      <Tooltip content="چاپ قبض" placement="top" color="primary">
                        <span>
                          <FaPrint
                            className="text-blue-600 cursor-pointer hover:text-blue-800 transition text-lg"
                            onClick={() => handlePrintReceipt(item)}
                            style={{ 
                              opacity: loadingPrintReceipt[item.id] ? 0.5 : 1,
                              pointerEvents: loadingPrintReceipt[item.id] ? 'none' : 'auto'
                            }}
                          />
                        </span>
                      </Tooltip>

                      <Tooltip content="حذف گزارش" placement="top" color="warning">
      <span>
        <FaTrash
          className="text-red-600 cursor-pointer hover:text-red-800 transition text-lg"
          onClick={async () => {
            if (!window.confirm("آیا میخواهید این گزارش حذف شود؟")) return;

            try {
              await deleteCargo({ id: item["id"] });
              toast.success("با موفقیت حذف شد!");
              window.location.reload();
            } catch {
              toast.error("خطا در حذف گزارش!");
            }
          }}
        />
      </span>
                      </Tooltip>
                    </div>
                  </td>

                </tr>
              ))}

              </tbody>
            </table>

          </div>
          </div>}

        {paging.length > 1 ? <Paginate links={paging} /> : null}

      </DashboardLayout>

      
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          className="mt-10 absolute inset-0 flex justify-center items-center z-10"
          onClick={handleCloseModal}
        >
          <div
            className="bg-white no-scrollbar overflow-y-auto h-1/2 dark:bg-boxdark p-6 rounded-lg max-w-3xl w-full shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-6 border-b border-gray pb-4">
              <h2 className="text-xl font-bold text-gray-700 dark:text-white">لیست اجناس</h2>
              <button
                onClick={handleCloseModal}
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="mb-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {selectedJens.map((subItem, index) => (
                <div
                  key={index}
                  className="bg-gray-50 dark:bg-gray-800 rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                    کالا: {subItem["jens"]["title"]}
                  </div>
                  <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                    کد کالا: {subItem["jens_code"]["title"]}
                  </div>
                  <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                    تعداد: {subItem["jens_unit"]}
                  </div>
                  <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                    شماره کالا: {subItem["jens_number"]}
                  </div>
                  <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                    واحد: {subItem["weight"]["title"]}
                  </div>
                  <div className="text-gray-700 text-lg dark:text-gray-200">
                    وزن: {subItem["weight_unit"]}
                  </div>
                </div>
              ))}
            </div>
            <MDButton
              color={"error"}
              onClick={handleCloseModal}
              className="mt-6 text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
            >
              بستن
            </MDButton>
          </div>
        </Modal>
      )}
    </div>
  );
}
